import { Box, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Frag } from "lib/@components/slot/frag"
import { hasAmendsContent } from "authoring/routes/project/amends/lib/amends-content"
import { If } from "lib/@components/switch"
import { htmlToText } from "lib/html-to-text"

export function ReturnedToEditingDialog({ content }) {
    const hasContent = hasAmendsContent(content)
    const textContent = hasContent ? htmlToText(content, true).trim() : ""

    return (
        <DialogBox Actions={Frag}>
            <Box
                sx={{
                    bgcolor: "background.neutral",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                <Typography variant="subtitle1" sx={{ mb: hasContent ? 0.5 : 0 }}>
                    Returned to Editing
                </Typography>
                <If truthy={hasContent}>
                    <Typography
                        data-cy="returned-to-editing-dialog-content"
                        variant="body2"
                        sx={{
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                        }}
                    >
                        {textContent}
                    </Typography>
                </If>
            </Box>
        </DialogBox>
    )
}
